// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { useOpenedIncomingPayment, getSafeCheckoutPaymentOptions } from '@tectonics/prs/incoming-payment';
import { getSafeSupportedFeatureByName } from '@tectonics/prs/support';

import lookAndFeel from '@tectonics/look-and-feel/volcanes';
import { getSupportedTraits } from '@tectonics/prs/feature';
import { intersect } from '@tectonics/commons/arrays';

import iconPuntoXpressSrc from '../display-puntoxpress-brand/icons/puntoxpress-icon.svg';
import { getCashMethodsCheckoutPaymentOptions } from '@tectonics/prs/incoming-payment/checkout-payment-options';

export function DisplayGuatemalanCashBrands(): Node {
  const incomingPayment = useOpenedIncomingPayment();
  const checkoutPaymentOptions = getSafeCheckoutPaymentOptions(incomingPayment);
  const cashMethodAllowedBrands = getCashMethodsCheckoutPaymentOptions(checkoutPaymentOptions);

  const supportedDisplayGuatemalanCashMethodsBrandFeature = getSafeSupportedFeatureByName(
    'display_guatemalan_accepts_cash_methods',
    lookAndFeel.prsSupport
  );

  const supportedBrands = getSupportedTraits(supportedDisplayGuatemalanCashMethodsBrandFeature);
  const brandsToDisplay = intersect(supportedBrands, cashMethodAllowedBrands);

  return (
    <Root>
      {brandsToDisplay.map(brand => (
        <CashMethodBrandImageWrapper key={brand}>
          <CashMethodBrandImage src={getBrandImageSrc(brand)} alt={brand} />
        </CashMethodBrandImageWrapper>
      ))}
    </Root>
  );
}

function getBrandImageSrc(cashMethod: string): string {
  switch (cashMethod) {
    case 'puntoxpress':
      return iconPuntoXpressSrc;

    default:
      throw new Error(`Display bank brand: there is no source for ${cashMethod}`);
  }
}

const Root = styled.div`
  height: 100%;
  display: flex;
`;

const CashMethodBrandImageWrapper = styled.div`
  flex-grow: 1;
  padding-left: 4px;
`;

const CashMethodBrandImage = styled.img`
  height: 100%;
  width: 100%;
`;
